/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Finanzierungsplan (Finanzierungsplan)
 * 
 * 401130001 = Gemeinnutzigkeitsnachweis (Gemeinnützigkeitsnachweis)
 * 
 * 401130002 = Antragsreport (Antragsreport)
 * 
 * 401130003 = Verwendungsnachweis (Verwendungsnachweis)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceDokumentenart {
 Finanzierungsplan = 401130000,
 Gemeinnutzigkeitsnachweis = 401130001,
 Antragsreport = 401130002,
 Verwendungsnachweis = 401130003
}

marker([
    "Enum.GlobalEnumsAceDokumentenart.Finanzierungsplan",
    "Enum.GlobalEnumsAceDokumentenart.Gemeinnutzigkeitsnachweis",
    "Enum.GlobalEnumsAceDokumentenart.Antragsreport",
    "Enum.GlobalEnumsAceDokumentenart.Verwendungsnachweis"
]);

export namespace GlobalEnumsAceDokumentenart
{
    class DataSets
    {
        static GlobalEnumsAceDokumentenartDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Finanzierungsplan", 401130000, "Finanzierungsplan"),
            new EnumValue("Gemeinnutzigkeitsnachweis", 401130001, "Gemeinnützigkeitsnachweis"),
            new EnumValue("Antragsreport", 401130002, "Antragsreport"),
            new EnumValue("Verwendungsnachweis", 401130003, "Verwendungsnachweis"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceDokumentenartDataSet;
    }
}
